import { DesktopOutlined } from "@ant-design/icons"
import { FC, useMemo } from "react"
import { withTranslation, WithTranslation } from "react-i18next"
import { QueryResult } from "../core/stores/data-store"
import SelectionInput from "../core/ui/form/selectionInput"
import { container } from "../inversify.config"

import { ApplicationsStore, ApplicationSummary } from "../stores/applications/applications-store"
import FloatSelectionInput from "../core/ui/form/floatSelectionInput"

export interface ApplicationReference {
  id: string
  name: string
}

const ApplicationEditor: FC<
  {
    idMode?: boolean
    disabled?: boolean
    searchType?: string
    minWidth?: number
    placeholder?: string
    value?: string
    valueAsItemReference: boolean
    onChange?: (value: ApplicationReference) => void
    onSelect?: (value: string) => void
    label?: string
    required?: boolean
  } & WithTranslation
> = ({ t, disabled, searchType, minWidth, placeholder, value, onChange, onSelect, i18n, ...props }) => {
  const currentStore = useMemo(() => container.get(ApplicationsStore), [])
  const currentState = currentStore.state

  const formatTitle = (application: ApplicationSummary) => {
    return application?.name
  }

  let getApplication = async (query: string, value: string) => {
    await currentStore.load({
      searchQuery: query,
      skip: 0,
      take: 1000
    })
    return {
      items: currentState.items.value.map((o) => ({ id: o.id ? `${o.id}` : null, title: formatTitle(o), })),
      count: currentState.count.value
    } as QueryResult<any>
  }

  return (
    <FloatSelectionInput
      content={(o: any) => (
        <div>
          <DesktopOutlined />
          <span>&nbsp;{o.title}</span>
        </div>
      )}
      searchable
      nullable
      multiple={false}
      onSelect={(item) => {
        if (onSelect) {
          onSelect(item.id || item)
        }
      }}
      valueAsItemReference
      disabled={disabled}
      minWidth={minWidth}
      placeholder={placeholder}
      query={getApplication}
      value={value}
      onChange={(item) => {
        if (onChange) {
          onChange(item ? { id: item.id, name: item.title } : null)
        }
      }}
      {...props}
    />
  )
}

export default withTranslation()(ApplicationEditor) as any
